<template>
  <d2-container>
    <el-form>
      <el-form :model="form" :rules="rules" ref="form" label-width="200px">
        <el-form-item v-for="item in systemData" :label="item.configDesc" prop="name">
          <input-value :value="item.value" @update:value="item.value = $event" :type="item.valueType" ></input-value>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="$router.back()">取 消</el-button>
        <el-button type="success" @click="confirm('form')">确定</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import inputValue from '@/components/InputValue'
import { getList, getEditSet, updateSets } from '@/api/demo/system/index'
export default {
  name: 'systemManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    inputValue
  },
  data () {
    return {
      tableKey: 0,
      systemData: [],
      systemManger_btn_edit: false,
      dialogFormVisible: false,
      form: {
        id: '',
        value: ''
      },
      rules: {
        id: [{ required: true, message: '请填写id', trigger: 'blur' }],
        value: [{ required: true, message: '请填写值', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getListS()
  },
  mounted () {},
  methods: {
    getListS () {
      let that = this
      getList().then(res => {
        that.systemData = res
      })
    },
    // 修改
    getEdit (id, value) {
      this.dialogFormVisible = true
      this.form.id = id
      this.form.value = value
    },
    // 取消
    cancel () {
      this.dialogFormVisible = false
    },
    // 确定
    getAdopt () {
      let that = this
      console.log('that.form', that.form)
      getEditSet(that.form).then(res => {
        that.getListS()
        this.dialogFormVisible = false
      })
    },
    confirm () {
      console.log(this.systemData)
      updateSets(this.systemData).then(res => {
        this.$notify({
          title: '成功',
          message: '修改成功',
          type: 'success',
          duration: 2000
        })
      })
    }
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
  align-items: center;
}
</style>
